import { Button } from "@/components/ui/button";
import { SheetActions, SheetHeader, SheetTitle } from "@/components/ui/sheet";
import { ExpenseCategoryGlPairing } from "@common/utils/graphql";
import { useState } from "react";
import { useForm } from "react-hook-form";
import { z } from "zod";
import { CreateEditCategorySheet } from "./CreateEditCategorySheet";
import { zodResolver } from "@hookform/resolvers/zod";
import { CategoryFormSchema } from "../forms/Forms";
import { formatDate } from "@common/components/utils";
import { AttributeKeyValueCell } from "@common/components";

interface Props {
  category: ExpenseCategoryGlPairing;
}

export const ViewCategoryDrawer = ({ category }: Props) => {
  const [editCategory, setEditCategory] = useState(false);
  const [shownCategory, setShownCategory] = useState(category);

  const form = useForm<z.infer<typeof CategoryFormSchema>>({
    resolver: zodResolver(CategoryFormSchema),
  });

  const onBack = (c?: ExpenseCategoryGlPairing) => {
    setEditCategory(false);
    if (c) setShownCategory(c);
  };

  if (editCategory) {
    return (
      <CreateEditCategorySheet
        form={form}
        onBack={onBack}
        category={category}
        mode="edit"
      />
    );
  }

  const header = (
    <SheetHeader>
      <SheetTitle>{shownCategory.categoryName}</SheetTitle>
    </SheetHeader>
  );

  const body = (
    <div className="p-sheet-gap">
      <AttributeKeyValueCell
        keyName="GL Account"
        value={shownCategory.glAccount}
        className="mb-5"
      />
      <AttributeKeyValueCell
        keyName="Disabled"
        value={!shownCategory.isShown ? "Yes" : "No"}
        className="mb-5"
      />
      <AttributeKeyValueCell
        keyName="Last Updated"
        value={formatDate(shownCategory.updatedAt)}
      />
    </div>
  );

  const actions = (
    <SheetActions>
      <Button className="w-full" onClick={() => setEditCategory(true)}>
        Edit Category
      </Button>
    </SheetActions>
  );

  return (
    <>
      {header}
      {body}
      {actions}
    </>
  );
};
